import { LoopWinsComponent } from "ags/components/loop-wins-component";
import { Components } from "appworks/components/components";
import { State } from "appworks/state-machine/states/state";

export class AgsLoopWinsState extends State {
    public onEnter(): void {
        Components.get(LoopWinsComponent).start().then(() => this.complete());
    }

    public onExit(): void {
        Components.get(LoopWinsComponent).end().execute();
    }

    public onSkip() {
        this.skip();
    }
}
